export const ANGULAR_STATIC_IMPORT_YAML = `project:
  name: recipe-angular
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: static
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-angular-static`;
